import React, { useState, useContext, useEffect } from "react"
import {
  Box,
  TextField,
  TextareaAutosize,
  Typography,
  Button,
} from "@material-ui/core"
import WhatsAppIcon from "@material-ui/icons/WhatsApp"
import { useStaticQuery, graphql } from "gatsby"
import { CartContext } from "./Context"
import TagPrice from "../widgets/TagPrice"
import ReactPixel from "react-facebook-pixel"
const encode = contact => {
  return Object.keys(contact)
    .map(
      key => encodeURIComponent(key) + "=" + encodeURIComponent(contact[key])
    )
    .join("&")
}
const Form = () => {
  let { cart, setCart } = useContext(CartContext)
  const data = useStaticQuery(graphql`
    query Whatsapp {
      sanitySetting {
        whatsapp {
          phone
        }
        money
      }
    }
  `)
  const money = data.sanitySetting.money
  const whatsappNumber = `${data.sanitySetting.whatsapp.phone.replace(
    / |\+|-/g,
    ""
  )}`
  const [userData, setUserData] = useState({
    address: "",
    name: "",
    lastName: "",
    phone: "",
    email: "",
  })
  const handleData = event => {
    setUserData({ ...userData, [event.target.name]: event.target.value })
  }

  let listProductsText = ""
  let totalPrice = 0
  const line = "........%0A"
  const addressText =
    userData.address !== "" ? `Mi dirección es: ${userData.address}` : ""

  useEffect(() => {
    ReactPixel.track("InitiateCheckout", {
      value: totalPrice,
      currency: money == "Bs" ? "BOB" : money,
    })
    typeof window !== "undefined" &&
      window.localStorage.getItem("userData") &&
      setUserData(JSON.parse(window.localStorage.getItem("userData")))
  }, [])
  useEffect(() => {
    typeof window !== "undefined" &&
      window.localStorage.setItem("userData", JSON.stringify(userData))
  }, [userData])

  if (cart.products.length !== 0) {
    cart.products.forEach(product => {
      listProductsText += line
      listProductsText += `✅ ${product.title} ${
        !product.variantName
          ? `_(${product.variants[0].price}${money}) x${
              product.variants[0].quantity
            }uds = ${
              product.variants[0].quantity * product.variants[0].price
            }${money}`
          : ""
      } _`
      if (product.variantName) {
        product.variants.forEach(variant => {
          totalPrice += variant.price * variant.quantity
          listProductsText += `${product.variantName}: ${variant.tag} (${
            variant.price
          }${money}) x${variant.quantity}uds. = ${
            variant.price * variant.quantity
          }${money}_`
        })
      } else {
        totalPrice += product.variants[0].quantity * product.variants[0].price
      }
    })
  }

  const message = `👋 Hola soy ${userData.name} _Deseo estos productos: _${listProductsText}_${line}_${addressText}_${line}Total a pagar: ${totalPrice} ${money}`

  const messageWhatsapp = message.replace(/ /g, "%20").replace(/_/g, "%0A")
  const submit = e => {
    // e.preventDefault()
    ReactPixel.track("CompleteRegistration", {
      value: totalPrice,
      currency: money == "Bs" ? "BOB" : money,
    })
    fetch("/", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: encode({ "form-name": "contact", ...userData }),
    })
  }
  return (
    <form>
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        flexDirection="column"
      >
        <Typography gutterBottom> Por favor llene sus datos</Typography>
        <TextField
          required
          value={userData.name}
          onChange={handleData}
          color="primary"
          variant="filled"
          label="Nombres"
          name="name"
        />
        <br />
        <TextField
          required
          value={userData.lastName}
          onChange={handleData}
          color="primary"
          variant="filled"
          label="Apellidos"
          name="lastName"
        />
        <br />
        <TextField
          required
          value={userData.phone}
          onChange={handleData}
          color="primary"
          variant="filled"
          label="Celular"
          name="phone"
        />
        {/* <br />
        <TextField
          required
          value={userData.email}
          onChange={handleData}
          color="primary"
          variant="filled"
          label="Email"
          name="email"
        /> */}
        <br />
        <TextField
          multiline
          value={userData.address}
          onChange={handleData}
          color="primary"
          variant="filled"
          label="Dirección"
          name="address"
          style={{ width: "100%" }}
        />
        <br />
        <TagPrice>
          Total: {totalPrice} {money}
        </TagPrice>
        <Button
          onClick={submit}
          style={{ background: "#25d366", color: "#ece5dd" }}
          fullWidth
          color="primary"
          variant="contained"
          component="a"
          target="_blank"
          href={`https://api.whatsapp.com/send?phone=${whatsappNumber}&text=${messageWhatsapp}`}
        >
          <WhatsAppIcon />
          Enviar pedido
        </Button>
      </Box>
    </form>
  )
}

export default Form
